import AppMenuItemData from "./context/AppMenuItemData";
import { SuperAppService } from "./services/SuperAppService";

declare global {
    interface Window {
        superAppService: SuperAppService
    }
}

export function delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function parseAppConfig(rootElem): {
    apiBaseUrls:string[],
    appId:string,
    merchantAppId: string,
    initialLang:string,
    externalMenuItems:AppMenuItemData[],
    smallCarSampleImageUrlPath: string
} | null {    
    if (rootElem instanceof Element) {
        if (rootElem.hasAttribute("data-api-base-urls")) {
            let externalMenuItems:AppMenuItemData[] = [];
            if(rootElem.hasAttribute("data-navbar-datalist-id")) {
                const datalistElemId = rootElem.getAttribute("data-navbar-datalist-id");
                if(datalistElemId) {
                    externalMenuItems = parseExternalMenuItems(datalistElemId);
                }                
            }

            let apiBaseUrls:string[] = rootElem.getAttribute("data-api-base-urls")!.split(";").map(it => it.trim());

            return {
                apiBaseUrls: apiBaseUrls,
                appId: <string>rootElem.getAttribute("data-app-id"),
                merchantAppId: <string>rootElem.getAttribute("data-merchant-app-id"),
                initialLang: rootElem.getAttribute("data-lang") || "my",
                externalMenuItems: externalMenuItems,
                smallCarSampleImageUrlPath: rootElem.getAttribute("data-small-sample-image-path") || "https://res.cloudinary.com/innoveller/image/upload/v1779702265/mmbusticket/promotion-photos/small-car-sample-5x4.webp"
            }
        }
    }
    return null;
}

function parseExternalMenuItems(datalistElemId:string): AppMenuItemData[] {
    const datalistElem = document.getElementById(datalistElemId);
    if(datalistElem) {
        // Get all the <option> elements within the datalist
        const options = datalistElem.querySelectorAll('option');

        // Convert the options to an array of menu item data
        const menuItems:AppMenuItemData[] = Array.from(options).map(option => {
            return {
                label: {
                    "en": option.getAttribute("data-label-en") || option.innerHTML,
                    "my": option.getAttribute("data-label-my") || option.innerHTML
                },
                href: option.value,
                priority: 1
            }
        });
        return menuItems;
    } else {
        return [];
    }
}